import { isGenericPromptInstructionType } from './const';
import type { PromptInstruction, PromptInstructionPlaceholder } from './types';

/**
 * Compares a "placeholder" with an "instruction" to determine if they match.
 */
export const comparePlaceholderAndInstruction = (
  placeholder: PromptInstructionPlaceholder,
  instruction: PromptInstruction
): boolean => {
  if (!placeholder || !instruction) {
    return false;
  }

  if (placeholder.instructionType !== instruction.type) {
    return false;
  }

  // For generic prompt instructions, compare the instruction text
  if (isGenericPromptInstructionType(placeholder.instructionType)) {
    return placeholder.instruction === instruction.text;
  }

  // For other types, compare the ID
  return placeholder.id === instruction.id;
};

export const isStructureInstructionsPresent = (structureInstructionsData?: { text?: string }) =>
  Boolean(structureInstructionsData?.text?.trim());
